const faqs = [
  {
    q: '吃瓜爆料网的内容来源是什么？',
    a: '我们的内容来自多渠道信息整合，包括公开媒体报道、社交平台动态、行业内部人士投稿以及用户分享。每条爆料在发布前都会经过编辑团队的多方核实和交叉验证，确保信息的相对准确性。同时我们也会明确标注信息来源和可信度等级，方便读者自行判断。',
  },
  {
    q: '网站需要注册才能看全部内容吗？',
    a: '不需要。吃瓜爆料网坚持开放访问原则，所有内容均可免费浏览，无需注册账号、无需登录、无需付费。我们没有任何内容墙或付费专区，每一个访问者都能享受完整的吃瓜体验。',
  },
  {
    q: '如何向吃瓜爆料网投稿爆料？',
    a: '你可以通过我们的官方投稿邮箱提交爆料内容。请尽量提供详细的文字描述和相关证据材料（截图、录音、文件等）。一经采用，我们会根据爆料的独家性和影响力给予相应的稿酬奖励。所有投稿人的个人信息都会被严格保密。',
  },
  {
    q: '网站的更新频率是怎样的？',
    a: '我们保持7×24小时全天候更新，编辑团队分为多个班次轮流值班。常规时段每30-60分钟会有一轮内容更新，如有重大突发事件发生，我们会在15分钟内完成首批信息的发布，并持续跟进事件进展。',
  },
  {
    q: '如何确保网站能够稳定访问？',
    a: '我们采用了多地服务器部署和CDN加速技术，确保全国各地的用户都能快速稳定地访问。如果遇到访问困难，建议尝试刷新页面或更换网络环境。我们也会定期在网站公告区发布最新的可用访问地址，请关注首页的地址发布信息。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="w-full max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">常见问题</h2>
          <p className="text-foreground-500 text-sm">关于吃瓜爆料网，你想知道的都在这里</p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70"
            >
              <h3 className="font-heading text-base text-foreground-900 mb-3 flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 rounded-lg bg-primary-100 text-primary-600 flex items-center justify-center text-xs font-bold mt-0.5">
                  Q
                </span>
                {faq.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-9">{faq.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}